<template>
  <div class="account-boxes">
    <DeployerUiBox :box-title="manageTexts.title">
      <DeployerAccountManagePlan />
    </DeployerUiBox>

    <DeployerUiBox
      v-if="accountStore.account?.plan?.plan_id"
      :box-title="cancelTexts.title"
      :box-text="cancelTexts.text"
    >
      <button
        type="button"
        class="btn grey-border red-text w100"
        @click.prevent="cancelPlan"
        v-html="cancelTexts.button_label"
      />
    </DeployerUiBox>
  </div>
</template>

<script setup>
const modalStore = useModalStore()
const textsStore = useTextsStore()
const accountStore = useAccountStore()
const manageTexts = computed(() => textsStore.account.plan.box_manage)
const cancelTexts = computed(() => textsStore.account.plan.box_cancel)

const cancelPlan = () => {
  modalStore.type = 'cancel-plan'
  modalStore.show = true
  modalStore.subtitle = cancelTexts.value.title
  modalStore.title = cancelTexts.value.are_you_sure
  modalStore.text = cancelTexts.value.modal_text
}
</script>

<style lang="scss" scoped></style>
